export default __webpack_public_path__ + "static/media/stage_completed.5d9a5dc8.svg";